import { render } from "./PaginationMenu.vue?vue&type=template&id=6377f1a5"
import script from "./PaginationMenu.vue?vue&type=script&lang=js"
export * from "./PaginationMenu.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/cube-viewer/cube-viewer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__